import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button, Radio,
  Input, Upload,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormSlideshow = ({
  handleSubmit, isEdit, isSubmit,
  handleUpload, imgFile, data,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue({
        title: data?.title || '',
        short_description: data?.short_description || '',
        url_name: data?.url_name || '',
        url: data?.url || '',
        video_url_name: data?.video_url_name || '',
        video_url: data?.video_url || '',
        status: data?.status || false,
      })
    }
  }, [data])

  const validateMessages = {
    required: "'${label}' is required!", // eslint-disable-line no-template-curly-in-string
  }

  return (
    <div>
      <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
        <h3 className="title-content mb-0">
          {isEdit ? 'Edit' : 'Add'}
          {' '}
          Slideshow
        </h3>
      </div>
      <Card className="pt-4">
        <Form
          {...formItemLayout}
          form={form}
          name="slideshow"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input placeholder="Title" />
          </Form.Item>

          <Form.Item label="Short Desc." name="short_description" rules={[{ required: true }]}>
            <Input.TextArea placeholder="Short Desc." rows={3} />
          </Form.Item>

          <Form.Item label="URL Name" name="url_name" rules={[{ required: true }]}>
            <Input placeholder="URL Name" />
          </Form.Item>

          <Form.Item label="URL" name="url" rules={[{ required: true }]}>
            <Input placeholder="URL" />
          </Form.Item>

          <Form.Item label="Video URL Name" name="video_url_name" rules={[{ required: true }]}>
            <Input placeholder="Video URL Name" />
          </Form.Item>

          <Form.Item label="Video URL" name="video_url" rules={[{ required: true }]}>
            <Input placeholder="Video URL" />
          </Form.Item>

          <Form.Item
            name="image"
            label="Image"
            valuePropName="imageFile"
            extra="Size maksimal 1MB"
            getValueFromEvent={handleUpload}
          >
            <Upload
              showUploadList={false}
              beforeUpload={() => false}
            >
              <React.Fragment>
                {imgFile && (
                  <img src={imgFile} className="icon-thumbnail-form mb-2" alt="category icon" />
                )}
                <div>
                  <Button icon={<UploadOutlined />}>Click to upload</Button>
                </div>
              </React.Fragment>
            </Upload>
          </Form.Item>

          <Form.Item name="status" label="Status" rules={[{ required: true }]} initialValue="inactive">
            <Radio.Group>
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
            <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Cancel</Button>
            <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Submit Change' : 'Create'}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

FormSlideshow.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
  handleUpload: PropTypes.func,
  imgFile: PropTypes.any,
  data: PropTypes.object,
}

export default FormSlideshow
